:host {
  display: block;

  --jump-search-bar-focus-color: var(--secondary-standard, #5E79BA);
  --jump-search-bar-border-color: var(--neutral-grey-secondary, #707070);
  --jump-search-bar-bg-color: var(--gray-ultralight, #F8F8F8);
  --jump-search-bar-dropdown-border-color: var(--neutral-grey-disabled, #CBCBCB);

  font-family: var(--ff-primary);

  jump-button {
    --jump-button-border-radius: 0px 3px 3px 0px;
  }

  .SearchBar {
    position: relative;

    &.focused .InputWrapper {
        border-color: var(--jump-search-bar-focus-color) !important;
    
        jump-icon {
          color: var(--jump-search-bar-focus-color) !important;
        }
    
        input {
          outline: none !important;
        }
      }
  }

  .SearchBar:not(.iconOnly) {
      display: flex;
      width: 100%;
  
      .InputWrapper {
        width: 100%;
        display: flex;
      }
  
      input {
        width: 100%;
        border: none;
      }
  
      /* Stile outline*/
      &.outline .InputWrapper {
        border: 1px solid var(--jump-search-bar-border-color);
        border-radius: 3px;
        padding: 12px;
        gap: 8px;
  
        jump-icon {
          color: var(--jump-search-bar-border-color);
        }
      }
  
      &.outline.withBtn .InputWrapper {
        border-radius: 3px 0px 0px 3px;
      }
  
  
      /* Stile filled */
      &.filled .InputWrapper {
        border: 1px solid var(--jump-search-bar-bg-color);
        background-color: var(--jump-search-bar-bg-color);
        border-radius: 3px;
        padding: 12px;
        gap: 8px;
  
        input {
          background-color: var(--jump-search-bar-bg-color);
        }
  
        jump-icon {
          color: var(--jump-search-bar-border-color);
        }
      }
  
      &.filled.focused.withBtn .InputWrapper {
        border-radius: 3px 0px 0px 3px !important;
      }
  
      /* Stile linear */
      &.linear .InputWrapper {
        border-bottom: 1px solid var(--jump-search-bar-border-color);
        padding-bottom: 4px;
  
        jump-icon {
          padding-right: 6px;
        }
      }
  }
    
 
  .Dropdown {

    &.dropAbsolute {
      position: absolute;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      width: 100%;
    }

    &.dropRelative {
      position: relative;
    }

   // position: absolute; la tolgo per il test
    margin-top: 10px;
    border-radius: 3px;
    border: 1px solid var(--jump-search-bar-dropdown-border-color);
    padding: 4px 16px;
    background-color: white;

    &__Recents {
      .title {
          color: #707070;
          font-size: 14px;
          line-height: 20px;
          padding: 8px 0;
          font-weight: 700;
          display: flex;
        }
    }

    &__Results {
      .totalRes {
        display: flex; 
        justify-content: space-between;
      }
    }
    

    .ResWrapper {
      display: flex;
      flex-direction: column;

      div {
        padding: 8px 0;
        color: #707070;
        font-size: 14px;
        display: flex;
        gap: 12px;
        align-items: center;

        img {
          width: 40px;
          height: 48px;
          object-fit: cover;
          border-radius: 3px;
        }
      }

      div:hover {
        cursor: pointer;
       }

       .helperText {
        color: #CBCBCB;

        svg {
          width: 25px;
          height: 25px;
        }
       }
    }
  }

/* Applicazione dell'animazione alla SearchBar.iconOnly.linear */
.SearchBar.iconOnly.linear {
  display: flex;
  width: 100%;

  .InputWrapper {
    width: 100%;
    display: flex;
    align-items: center;
    transition: border-bottom 0.3s ease;
    /* Transizione solo per il bordo inferiore */
    border-bottom: 1px solid transparent;
    /* Nessun bordo inizialmente */
    padding-bottom: 4px;
    overflow: hidden;
    /* Per nascondere il contenuto che esce dai limiti dell'InputWrapper */

    jump-icon {
      padding-right: 6px;
      /* Padding dell'icona */
    }

    input {
      width: 0;
      /* Imposta la larghezza iniziale a 0 */
      border: none;
      transform: translateX(-100%);
      /* Sposta l'input fuori dalla vista */
      transition: width 0.3s ease, transform 0.3s ease;
      /* Transizioni separate per width e transform */
      animation: none;
      /* Disabilita l'animazione predefinita */
    }
  }

  &.expanded {
    .InputWrapper {
      border-bottom: 1px solid var(--jump-search-bar-border-color);
      /* Mostra il bordo inferiore quando espanso */
      transition: border-bottom 0.3s ease;
      /* Transizione per il bordo inferiore */

      input {
        width: 100%;
        /* Espande l'input a tutta la larghezza disponibile */
        transform: translateX(0);
        /* Riposiziona l'input nella vista */
        animation: slide-right 0.3s ease forwards;
        /* Applicazione dell'animazione slide-right */
      }
    }
  }
}
            
}

@keyframes slide-right {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes border-slide-right {
  from {
    border-bottom-width: 0;
  }

  to {
    border-bottom-width: 1px;
  }
}